import {isCustomEventSupported} from "../../../../util/api/util";


export class FeedbackEventPublisher {
    publish(newContext: {[key: string]: string}) {
        if (isCustomEventSupported()) {
            const feedback = document.getElementById("PVWebFeedbackWidgetPubSub")
            const event =
                new CustomEvent(
                    "dvWebFeedbackContextChangeEvent",
                    {
                        detail: {
                            pageContext: newContext
                        }
                    }
                )
            feedback && feedback.dispatchEvent(event)
        }

    }
}